export default __webpack_public_path__ + "static/media/VG.a02e2f98.svg";